
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.28 29.187c.333.218.65.415.95.593a24.87 24.87 0 001.43-.916V24.67c-.019-.118-.02-.24 0-.363V10.23h-2.38v18.957zm4.6-2.03V24.66l3.06-9.209 2.26.75-2.855 8.586a28.982 28.982 0 01-2.465 2.371zm9.13-13.317a36.764 36.764 0 01-2.343 4.995l.713-2.145c.17-.51.13-1.05-.11-1.53-.24-.47-.65-.83-1.16-1l-2.69-.89c-1.04-.35-2.18.22-2.53 1.27l-1.01 3.04v-7.57c0-1.11-.9-2.01-2.01-2.01h-2.83c-1.1 0-2 .9-2 2.01v1.08a2.003 2.003 0 00-1.13-.24l-2.82.24c-.53.04-1.01.29-1.36.7-.35.41-.51.93-.47 1.46l.131 1.571-2.65.719a1.965 1.965 0 00-.499.215 38.446 38.446 0 01-.791-1.915c-.18-.47-.66-.76-1.16-.71-.5.05-.91.44-.98.94-2.168 14.62 7.484 30.548 14.103 37.184a1.102 1.102 0 00.817.356 1.118 1.118 0 00.79-.33c6.61-6.61 16.3-22.57 14.13-37.21-.07-.5-.48-.88-.98-.94-.5-.05-.98.24-1.16.71zM31.34 47.65c5.605-6.6 11.684-18.086 11.88-28.85-3.746 7.182-8.715 11.042-11.88 12.913V47.65zm-2.22-15.937c-3.164-1.871-8.133-5.73-11.88-12.913.197 10.764 6.276 22.24 11.88 28.848V31.713zM23.49 13.29l.212 2.513c.037.134.048.274.034.412l.753 8.967c.87.906 1.73 1.688 2.552 2.36v-.472l-1.17-13.98-2.38.2zm-3.95 4.34l2.04-.552.43 5.166a32.868 32.868 0 01-2.072-3.158l-.397-1.456z"}})])
          )
        }
      }
    